<template>
  <section class="form__thanks">
    <div class="form__thanks__wrapper">
      <div class="form__row form__row--thanks">
        <div
          class="form__group"
          data-size="auto"
        >
          <p v-html="`${translate('TXTLINE1', $store.state.lang)} ${name},`" />
          <div class="form__line"/>
        </div>
      </div>

      <div class="form__row form__row--thanks">
        <div
          class="form__group"
          data-size="auto"
        >
          <p v-html="translate('TXTLINE2', $store.state.lang)" />
          <div class="form__line"/>
        </div>
      </div>

      <div class="form__row form__row--thanks">
        <div
          class="form__group"
          data-size="auto"
        >
          <p v-html="translate('TXTLINE3', $store.state.lang)" />
          <div class="form__line"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import translate from '@/assets/i18n';

export default {
  name: 'FormThanks',

  data() {
    return {
      translate,
    };
  },

  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.form__thanks {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  flex-flow: row wrap;
  align-items: center;

  .form__row {
    height: rem(70px);

    @include mq(ipadL) {
      height: rem(90px);
    }
  }

  &__wrapper {
    position: relative;
  }

  p {
    margin: 0;
    @include fluid-type(375px, 1920px, 26px, 65px, 35px, 82px);
    color: $color-text;
  }
}

.form__line {
  display: none;

  @at-root [data-theme="default"] & {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;

    background: $color-label;
  }
}

.form__back {
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: 0.875rem;

  color: $color-text;

  a {
    display: inline-block;
    vertical-align: sub;
    margin-left: 2px;
  }
}
</style>
